import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { datadogInit } from "../../hooks/useLogging/Logging-utils";
import Loading from "../loading";
import { APPLICATION_NAME } from "./LoggingContext.request";
export const LoggingProvider = ({ data, loading, error, children }) => {
    useEffect(() => {
        let mounted = true;
        if (mounted && data) {
            datadogInit(data.dataDogClientToken, data.environment, data.buildVersion, APPLICATION_NAME);
        }
        return () => {
            mounted = false;
        };
    }, [loading, data]);
    if (loading || !data)
        return _jsx(Loading, { viewportHeight: "75vh" });
    if (error) {
        return _jsx(Loading, { error: true, text: error, viewportHeight: "75vh" });
    }
    return (_jsx(LoggingContext.Provider, Object.assign({ value: {
            application: APPLICATION_NAME,
            buildVersion: data.buildVersion,
            dataDogClientToken: data.dataDogClientToken,
            environment: data.environment,
            graphQLEndpoint: data.graphQLEndpoint,
            isLogRocketEnabled: data.isLogRocketEnabled,
            errorMessage: data.errorMessage,
            success: data.success,
        } }, { children: children })));
};
export const initEnvironmentDetails = {
    application: APPLICATION_NAME,
    buildVersion: "",
    dataDogClientToken: "",
    environment: "",
    graphQLEndpoint: "",
    isLogRocketEnabled: false,
    errorMessage: "",
    success: false,
};
export const LoggingContext = React.createContext(initEnvironmentDetails);
